import { useTranslation } from 'react-i18next';
import Select from './Select';

const SelectGenero = ({ inputRef, errors, className, label, ...rest }) => {
  const { t } = useTranslation();

  const genero = [
    { valor: 'F', descricao: t('cadastro.forms.options.female') },
    { valor: 'M', descricao: t('cadastro.forms.options.male') },
    { valor: 'O', descricao: t('cadastro.forms.options.other') },
    { valor: 'N', descricao: t('cadastro.forms.options.not_informed') },
  ];

  return (
    <>
      <Select
        className={className}
        options={[
          { label: t('cadastro.forms.options.select'), value: '' },
          ...genero.map((item) => ({
            value: item.valor,
            label: item.descricao,
          })),
        ]}
        name="genero"
        inputRef={inputRef}
        errors={errors}
        label={label}
        id="genero"
        {...rest}
      />
    </>
  );
};

export default SelectGenero;
